export const STOCK_VARIABLES = [
  { key: "height", label: "Height" },
  { key: "front_upright_height", label: "Front Upright Height" },
  { key: "rear_upright_height", label: "Rear Upright Height" },
  { key: "reinforced_height", label: "Reinforced Height" },
  { key: "width", label: "Width" },
  { key: "depth", label: "Depth" },
  { key: "length", label: "Length" },
  { key: "thickness", label: "Thickness" },
  { key: "gauge", label: "Gauge" },
  { key: "level_width", label: "Level Width" },
  { key: "level_depth", label: "Level Depth" },
  { key: "bolts_per_footplate", label: "Bolts per Footplate", isNumeric: true, isHideMM: true },
  { key: "dividers_per_shelf", label: "Dividers per Shelf", isNumeric: true, isHideMM: true },
  { key: "connecting_points", label: "Connecting Points", isNumeric: true, isHideMM: true },
  { key: "holes_drilled", label: "Holes Drilled", isNumeric: true, isHideMM: true },
  { key: "first_beam_level", label: "1st Beam Level" },
  { key: "frame_type", label: "Frame Type" },
  { key: "foot_type", label: "Foot Type" },
  { key: "shelf_reinforcers", label: "Shelf Reinforcers", isNumeric: true, isHideMM: true },
  { key: "crossties", label: "Crossties", isHideMM: true },
  { key: "pallet_supports", label: "Pallet Supports", isNumeric: true, isHideMM: true },
  { key: "chipboard_supports", label: "Chipboard Supports", isNumeric: true, isHideMM: true },
  { key: "v_type", label: "Type" },
  { key: "drop", label: "Drop" },
  { key: "custom_drop", label: "Custom Drop" },
  { key: "first_shelf_level", label: "1st Shelf Level" },
  { key: "finish", label: "Finish" },
  { key: "color", label: "Color" }
];

export const getVariableLabel = (key: string): string => {
  const variable = STOCK_VARIABLES.find(v => v.key === key);
  return variable ? variable.label : key;
};
